import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import Users from './modules/users'
import Shared from './modules/shared'
import Product from './modules/product'
import Communication from './modules/communication'
import Copy from './modules/copy'
import Logs from './modules/logs'
import UrlTools from './modules/urltools'
import PushWebLogs from './modules/push_web_logs'
import SplitTest from './modules/splitTest'
import PushWeb from './modules/push_web'
import MessageForm from './modules/messageForm'
import UserManagement from './modules/user_management'
import Facebook from './modules/facebook'

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Shared,
    Product,
    Users,
    Communication,
    Copy,
    Logs,
    UrlTools,
    PushWebLogs,
    SplitTest,
    PushWeb,
    MessageForm,
    UserManagement,
    Facebook
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js